/**
 * Color Theme Presets
 * 
 * Define color themes here. To switch themes, update ACTIVE_THEME below.
 * The applyTheme() function can be called to dynamically apply a theme.
 */

export interface ColorTheme {
  name: string;
  brandPrimary: string;
  brandPrimaryHover: string;
  brandPrimaryLight: string;
}

export const COLOR_THEMES: Record<string, ColorTheme> = {
  default: {
    name: 'Default (Blue-Gray)',
    brandPrimary: '#3d4f5f',
    brandPrimaryHover: '#4a5d6e',
    brandPrimaryLight: '#5a7080',
  },
};

// Change this to switch the active theme
export const ACTIVE_THEME: keyof typeof COLOR_THEMES = 'default';

/**
 * Apply a color theme by setting CSS variables on :root
 */
export function applyTheme(themeKey: string): void {
  const theme = COLOR_THEMES[themeKey];
  if (!theme) {
    console.warn(`Theme "${themeKey}" not found, using default`);
    return applyTheme('default');
  }

  const root = document.documentElement;
  root.style.setProperty('--brand-primary', theme.brandPrimary);
  root.style.setProperty('--brand-primary-hover', theme.brandPrimaryHover);
  root.style.setProperty('--brand-primary-light', theme.brandPrimaryLight);
}

/**
 * Get the current active theme
 */
export function getActiveTheme(): ColorTheme {
  return COLOR_THEMES[ACTIVE_THEME];
}
